import { Center, Loader } from '@mantine/core';
import { useEffect, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * RedirectPage redirects the user to a specified path based on query parameters.
 *
 * Query parameters:
 * - `to`: The path to redirect to (required)
 * - `delay`: The delay in milliseconds before redirecting (optional, default: 0)
 * - `showLoading`: Whether to show a loading spinner during the delay (optional, default: false)
 *
 * Example usage:
 * `/redirect?to=/welcome&delay=2000&showLoading=true`
 */
export default function RedirectPage() {
  const [searchParams] = useSearchParams();
  const [shouldRedirect, setShouldRedirect] = useState(searchParams.get('delay') === null);

  const to = searchParams.get('to') || '/';
  const delay = parseInt(searchParams.get('delay') || '0', 10);
  const showLoading = searchParams.get('showLoading') === 'true';

  useEffect(() => {
    if (delay > 0) {
      const timer = setTimeout(() => {
        setShouldRedirect(true);
      }, delay);

      return () => clearTimeout(timer);
    } else {
      setShouldRedirect(true);
    }
  }, [delay]);

  if (shouldRedirect) {
    return <Navigate to={to} replace />;
  }

  if (showLoading) {
    return (
      <Center style={{ height: '100vh' }}>
        <Loader size="lg" />
      </Center>
    );
  }

  return null;
}
